import { render, staticRenderFns } from "./PaginaAdminProcurador.vue?vue&type=template&id=17de3516"
import script from "./PaginaAdminProcurador.vue?vue&type=script&lang=js"
export * from "./PaginaAdminProcurador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports